import React, { PropsWithChildren } from 'react';
import classnames from 'classnames';
import styles from './SGSTextButton.module.scss';

type Props = {
    color: 'blue' | 'orange' | 'midblue' | 'gray';
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    className?: string;
    onClick: Function;
    variant?: 'contained' | 'outlined';
    size?: string;
    icon?: string;
};

const SGSTextButton: React.FC<PropsWithChildren<Props>> = ({ color, type = 'button', disabled = false, className, onClick, children, variant = 'contained', size, icon }) => {
    return (
        <button
            type={type}
            disabled={disabled}
            className={classnames(styles.btn, styles[`btn__${variant}`], styles[`btn__${variant}__${color}`], size === 'large' && styles.btn__large, disabled && styles.btn__disabled, className)}
            onClick={() => onClick()}
        >
            {icon && <i className={classnames(icon, 'mr-2')} />}
            {children}
        </button>
    );
};

export default SGSTextButton;
